import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';
import { useComanda } from './ComandaContext';
import { ComandaItem } from '../../../models/controleBar/comandas/ComandaItem';

const ComandaItemContext = createContext();
export const useComandaItem = () => useContext(ComandaItemContext);


export const ComandaItemProvider = ({ children }) => {    
    const { comandasByMesa, setComandasByMesa } = useComanda();
    const [comandaItemSel, setComandaItemSel] = useState(new ComandaItem());
    const [comandaItens, setComandaItens] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchItens = useCallback(async (comandaId) => {
        try {
            const result = await fetchData('/ComandaItem/GetByComandaId', { comandaId });
            setComandaItens(result);
        } catch (error) {
            console.error("Erro ao buscar itens da comanda:", error);
            showMessage(`Erro ao buscar itens! ${error?.message || error}`, 'danger');
        }
    }, []);

    const atualizarComandasLocal = (comandaId, novoItem, tipo) => {
        if (!comandasByMesa || comandasByMesa.length === 0) return;

        setComandasByMesa(prevComandas =>
            prevComandas.map(comanda => {
                if (comanda.id !== comandaId) return comanda;

                let itensAtualizados = comanda.comandaItens || [];

                if (tipo === 'add') {
                    itensAtualizados = [...itensAtualizados, novoItem];
                } else if (tipo === 'update') {
                    itensAtualizados = itensAtualizados.map(i => i.id === novoItem.id ? novoItem : i);
                } else if (tipo === 'delete') {
                    itensAtualizados = itensAtualizados.filter(i => i.id !== novoItem.id);
                }

                return {
                    ...comanda,
                    comandaItens: itensAtualizados
                };
            })
        );
    };

    const addItem = async (item) => {
        try {
            const result = await postData('/ComandaItem', item);
            setComandaItens(prev => [...prev, result]);
            atualizarComandasLocal(item.comandaId, result, 'add');
            showAlert('Item adicionado com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao adicionar item:", error);
            showMessage('Erro ao adicionar item!\n' + error, 'danger');
        }
    };

    const addItemList = async (itens) => {
        if (!itens || itens.length === 0) return;

        try {
            const result = await postData('/ComandaItem/AddList', itens); 
            // supondo que sua API receba uma lista e retorne os itens salvos

            setComandaItens(prev => [...prev, ...result]);

            // Atualiza o estado de cada comanda localmente
            if (Array.isArray(result)) {
                result.forEach(novoItem => {
                    atualizarComandasLocal(novoItem.comandaId, novoItem, 'add');
                });
            }

            showAlert('Itens adicionados com sucesso!');
            return result;
        } catch (error) {
            console.error("Erro ao adicionar lista de itens:", error);
            showMessage('Erro ao adicionar itens!\n' + error, 'danger');
        }
    };

    const updateList = useCallback(async (items) => {
        try {
            const response = await putData("/ComandaItem/UpdateList", items);
            return response;
        } catch (error) {
            showMessage("Erro ao atualizar itens da comanda", "error");
            throw error;
        }
    }, [showMessage]);


    const updateItem = async (item) => {
        try {
            const result = await putData('/ComandaItem', item);
            setComandaItens(prev =>
                prev.map(i => (i.id === result.id ? result : i))
            );
            atualizarComandasLocal(item.comandaId, result, 'update');
            showAlert('Item atualizado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar item:", error);
            showAlert('Erro ao atualizar item!', 'danger');
        }
    };

    // ✔ Deletar item
    const deleteItem = async (id, motivo) => {
        try {
            await deleteData('/ComandaItem', { id, motivo });
            setComandaItens(prev => prev.filter(i => i.id !== id));
            //atualizarComandasLocal(item.comandaId, item, 'delete');
            showAlert('Item excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir item:", error);
            showAlert('Erro ao excluir item!', 'danger');
        }
    };


    return (
        <ComandaItemContext.Provider
            value={{
                comandaItens,
                setComandaItens,
                comandaItemSel, 
                setComandaItemSel,
                addItem,
                addItemList,   // <-- novo aqui
                updateItem,
                updateList,
                deleteItem,
                fetchItens
            }}
        >
            {children}
        </ComandaItemContext.Provider>
    );

};
